import Autocomplete from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import { oneOfType, arrayOf, string, func, bool, object } from 'prop-types'

export const CvsChipInput = ({ onChange, value, allowDuplicates: _allowDuplicates, ...rest }) => {
  const handleDeleteChip = chipToDelete => () => {
    onChange(value.filter(chip => chip !== chipToDelete))
  }

  return (
    <Autocomplete
      multiple
      freeSolo
      autoSelect
      options={[]}
      value={typeof value === 'undefined' ? [] : value}
      onChange={(event, newValue) => onChange(newValue)}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={option}
            label={option}
            {...getTagProps({ index })}
            onDelete={handleDeleteChip(option)}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          {...rest.InputProps}
          variant="outlined"
          label={rest.label}
          placeholder={rest.placeholder}
        />
      )}
      {...rest}
    />
  )
}

CvsChipInput.propTypes = {
  value: oneOfType([string, arrayOf(string)]),
  onChange: func,
  allowDuplicates: bool,
  rest: object,
}
